import { notify } from "@/shared/utils/notify";
import { useNavigate } from "react-router-dom";

import {
  deleteListCustomerGroups,
  refreshTableListCustomerGroups,
  setListCustomerGroupsForUpdate,
  setIsListCustomerGroupsForUpdate,
} from "../../../redux";
import { DataListCustomerGroups } from "../../../redux/@types";
import useAppDispatch from "../../../redux/hooks/useAppDispatch";
import { useListCustomerGroups } from "./useListCustomerGroups";

export const useTableListCustomerGroups = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { tableProps } = useListCustomerGroups();

  const changeListCustomerGroupsForUpdate = async (
    val: DataListCustomerGroups,
  ) => {
    dispatch(setIsListCustomerGroupsForUpdate(true));
    dispatch(setListCustomerGroupsForUpdate(val));
    navigate(`/listCustomerGroups/${val.id}`);
  };

  const removeListCustomerGroup = async (valId: number) => {
    try {
      await deleteListCustomerGroups(valId);
      dispatch(refreshTableListCustomerGroups(true));
      notify.success(
        `Se ha borrado con éxito el grupo de clientes con id:${valId}`,
      );
      tableProps?.refresh();
    } catch (err: any) {
      console.log({ err });
      notify.error(err?.message || "No se pudo eliminar el grupo");
    }
  };

  return {
    changeListCustomerGroupsForUpdate,
    removeListCustomerGroup,
  };
};
